import {createLelkeszApp, prepareRouter} from '@/helpers/main';
import Api from '@/api';
import router from '@/router';

prepareRouter(Api, router).then(() => {
  createLelkeszApp(router);
});
